import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";

import { Spinner, Title, ActionButton } from "../../../components/atoms";
import { Modal } from "react-responsive-modal";
import { VerticalPrintAddress,
} from "../../../components/organisms";
import {
  PrintProductList,
  PrintItemsList,
  PrintHeader,
 
} from "../../../components/molecules";
import { FaCheckCircle, FaFileAlt, FaPrint } from 'react-icons/fa';


import { GETSERVICELABELS, CONFIRMSERVICELABELPRINT } from "../../../api/apiConfig";
import {
  apiPost,
  printLabel1,
  appTitle,
  
  businessAddress,
  businessEmail,
  businessUrl,
  AnalyticsService,
 
} from "../../../utils";
import { Grid, Stack, Paper, Stepper, Step, StepLabel, Typography, Box, Button} from "@mui/material";

import { useMediaQuery } from "react-responsive";
import {PrintAllSlipInOne} from "./PrintAllSlipInOne";



export const ServicePackagingSlip = () => 
{
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const [dateToday, setDateToday] = useState(moment().format("h:mm a"));
  const [showReturnLabels, setShowReturnLabels] = useState(false);
  const [data, setData] = useState();
  const [prodImg, setProdImg] = useState();
  const [isLoading, setIsLoading] = useState(false);  
  const [returnLabels, setReturnLabels] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState({});
  const [printLoading, setPrintLoading] = useState(false);
  const [hasPrinted, setHasPrinted] = useState(true);
  const [finishLoading, setFinishLoading] = useState(false);
  
  
  
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const paramValue = queryParams.get('service');

  const location = useLocation();
  const queryString = location.search;
  
  const paramValue = queryString.match(/[?&]service=([^&]+)/)?.[1];
  
 const OnBoardingHeader = ()=>{

    return (
        <div className="appHeaderSec" style={{position:'relative'}}>
        <div className="logo-and-title nowrap space-right2">
          
          <img src={require('../../../assets/images/logo2.png')} className={"header-logo"} alt="Logo image" />
          
          <div className={`multiSec leftHeader `} >
              <Stack direction={"row"} spacing={2} className="center">
                
                  <Title className={"headerTxtUprLeft nowrap"} text={"THE CRICKET STORE"} />
                
                
              </Stack>
              <Title className={"headerTxtBtmLeft nowrap"} text={"Services"} />
          </div>
          
        
        </div>
        </div>
    )
}

  const getDetails = async () => {
    
    console.log("paramValue", paramValue);
    const res = await apiPost(GETSERVICELABELS, { reference: paramValue });
    
    if (res) {
      setData(res);
      const productImage = await imageUrlToBase64(res.productImage);
      setProdImg(productImage);
      setReturnLabels(res.returnLabel?.split(";"));
    };
        
         
  }
    
  

  useEffect(async () => {
    AnalyticsService.logEvent("SERVICE_PACKAGING_SLIP_PAGE_VIEW");
    setIsLoading(true);
   // await getNewOrders();
  
   
    await getDetails();
    setIsLoading(false);
    setInterval(() => {
      setDateToday(moment().format("h:mm a"));
    }, 1000);

    return () => {
      setDateToday("");
    };

  }, []);

  

  
  const onPrintBtnClick = async () => {
    if(isLoading) return;
 
   setPrintLoading(true);
    
    const bodyCopy = document.getElementById('PrintSection');
    const clonedCopy = bodyCopy.cloneNode(true);
    clonedCopy.style.display = 'block';
    
    await PrintAllSlipInOne(clonedCopy, data.shippingLabel, data.returnLabel);
    setPrintLoading(false);
    setHasPrinted(false)
    
    AnalyticsService.logEvent("WINDOW_PRINT_CLICKED");
  };
  const onConfirmLabelsPrint = async () => {

    setFinishLoading(true)
    const res = await apiPost(CONFIRMSERVICELABELPRINT, { reference: data.lineItemId.toString() });

    setFinishLoading(false);
    window.location.href = 'about:blank'; 
   

  }

  const onPrintFedExShippingClick = () => {
    if(isLoading) return;
    document.getElementById("shipLabel").click();
  };

  const onPrintFedExReturnClick = () => {
    if(isLoading) return;
    //setShowReturnLabels(true);
     document.getElementById("returnLabel").click();
  };
  async function imageUrlToBase64(imageUrl) {
    try {
        // Fetch image data from the URL
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        // Convert blob to base64 string
        const reader = new FileReader();
        reader.readAsDataURL(blob);

        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
        });
    } catch (error) {
        console.error('Error fetching image:', error);
        return imageUrl; // Return original URL on error
    }
  }     

  const steps = [
    { label: "Step 1: Print 3x Slips", icon: <FaPrint /> },
    { label: "Step 2: Send Parcel", icon: <FaCheckCircle /> },
    
  ];
  

  const handleNext = () => {
    setCompletedSteps((prev) => ({ ...prev, [activeStep]: true }));
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompletedSteps({});
    setHasPrinted(true);
  };

  const renderStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return  <Grid container direction="column" alignItems={"center"} alignContent={"center"} textAlign={"center"} spacing={2} style={{columnGap:'30px'}}>
        <Grid item>
                <Button startIcon={printLoading && <Spinner color={"black"} loading={printLoading} size={15} />} variant="contained" style={{backgroundColor:'#ea1515', borderRadius:'15px', textTransform: 'none !important'}} sx={{ textTransform: 'none'}} onClick={()=>onPrintBtnClick()}>Print 3x Shipping Labels</Button>
        </Grid>
        <Grid item >
         <p className="headerTxt">Once printed, please take your parcel to your nearest FedEx drop-off location.
         </p>
         </Grid>
         <Grid item>
         <Button variant="contained" sx={{ textTransform: 'none'}} style={{backgroundColor:'#660099', borderRadius:'15px', textTransform: 'none'}} onClick={()=> {window.location.href = "https://local.fedex.com/en-gb";}}>Find my nearest FedEx drop-off point</Button>
         </Grid>
        
         <Grid item>
         <Button startIcon={finishLoading && <Spinner color={"black"} loading={finishLoading} size={15} />} style={{backgroundColor:hasPrinted?'grey':'green', borderRadius:'15px' }} variant="contained" onClick={()=>{onConfirmLabelsPrint()}} disabled={hasPrinted}>
                      Finish
          </Button>
         </Grid>
         
       </Grid>;
      // case 1:
      //   return <Grid container direction="column" alignItems={"center"} alignContent={"center"} textAlign={"center"} spacing={2} style={{columnGap:'30px'}}>
      //   <Grid item>
      //           <Button startIcon={printLoading && <Spinner color={"black"} loading={printLoading} size={15} />} variant="contained" style={{backgroundColor:'#ea1515', borderRadius:'15px', textTransform: 'none !important'}} sx={{ textTransform: 'none'}} onClick={()=>onPrintBtnClick()}>Print 3x Shipping Labels</Button>
      //   </Grid>
      //    <Grid item>
      //    <Button variant="contained" sx={{ textTransform: 'none'}} style={{backgroundColor:'#ea1515', borderRadius:'15px', textTransform: 'none'}} onClick={()=> {window.location.href = "https://local.fedex.com/en-gb";}}>View Nearest FedEx Location</Button>
      //    </Grid>
      //   <Grid item >
      //    <p className="headerTxt">Now package the parcel and drop off at the nearest FedEx location.
      //    </p>
      //    </Grid>
         
         
      //  </Grid>;
      
      default:
        return "Unknown step";
    }
  };
  return (
    <>
    {data ? (<div id="packingSlipElement">

  
  <OnBoardingHeader/>
  <Grid container justifyContent={"center"}>
      <Paper
        style={{
          marginTop: "20px",
          width: "95%", 
          padding: "20px", 
          boxShadow: "0px 4px 20px rgba(0,0,0,0.1)", 
          borderRadius:'15px'
        }}
      >
        <Grid container flexDirection={'column'} justifyContent="center" alignItems={"center"} spacing={5} style={{marginTop:'15px'}}>
        <Grid item>
          <Title className={"headerTxt "} text={"Please complete the steps below:"} />
        </Grid>
        <Grid item>
          <Box sx={{ width: "100%", padding:'10px'}}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((step, index) => (
                <Step key={index} completed={!!completedSteps[index]}>
                  <StepLabel icon={step.icon}>{step.label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <div >
             
                <Box sx={{ mt: 2 }}>
                  {renderStepContent(activeStep)}
                 
                </Box>
              
            </div>
          </Box>
          </Grid>
        </Grid>
      </Paper>
      </Grid>
    

<div id="PrintSection" style={{marginTop:'100px', display:'none'}}>
  <div  className="printSection">
    <PrintHeader
      title={"The Cricket Store"}
      orderNumber={data.orderNumber}
      dateToday={moment().format("Do MMM YYYY")}
    />
    <div className="printAd">
      <VerticalPrintAddress
        label={"SHIP TO"}
        address1={data.merchantStreetAddress || "N/A"}
        address2={ "N/A"}
        postalCode={data.merchantPostalCode || "N/A"}
        city={data.merchantCity || "N/A"}
        country={"GB"}
        ifText
        text={"N/A"}
        ifCustomerName
        customerName={data.merchantName || "N/A"}
      />
      <VerticalPrintAddress
        label={"BILL TO"}
        address1={data.customerAddress1 || "N/A"}
        address2={data.customerAddress2 || "N/A"}
        postalCode={data.customerPostalCode || "N/A"}
        city={data.customerCity || "N/A"}
        country={data.customerCountry || "N/A"}
        ifCustomerName
        customerName={data.customerName || "N/A"}
      />
    </div>
    <div className="printSpinner">
      <Spinner color={"black"} loading={isLoading} size={40} />
    </div>
    <div className="printAd spacing">
      <div>
        <Title text={"ITEMS"} className="printTopTitle" />
        
                <PrintProductList
                  key={56789}
                  productName={data.productTitle || "N/A"}
                  variantName ={""}
                  productImage={prodImg                        
                  }
                  isImage={true}
                />
            
      </div>
      <div>
        <Title text={"QUANTITY"} className="printTopTitle" />
      
          <div>
            
                  <PrintItemsList
                    key={12345}
                    label={"QUANTITY"}
                    quantity={`${data.orderQuantity} of ${data.orderQuantity}` || "N/A"}
                  />
                
          </div>
      
      </div>
    </div>
    <div className="printFooter">
      <Title text={printLabel1} className="printfooterText text" />
      <Title text={appTitle} className="printFooterBold text" />
      <Title text={businessAddress} className="printFooterNormal text" />
      <Title text={businessEmail} className="printFooterNormal text" />
      <Title text={businessUrl} className="printFooterNormal text" />
    </div>
  </div>
</div>
</div>): (<div style={{
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  height: '100vh'
                }}>
            <Spinner color={"black"} loading={isLoading} size={40} />
          </div>)}
      
    </>  
  )
}


